import React from 'react';
import ShipmentDetails from './browse_shipment_detail.jsx';
import './browse_package_list.less';
import $ from 'jquery';
import RadioButton from '../components/radio_button/radio_button';
import { browserHistory } from 'react-router';
import MediaQuery from 'react-responsive';
import {commonFunctions} from './browser_common';
import  BrowseFilter from './browse_filter/browse_filter';
import ShowError from '../components/error/show_error.jsx';
import SuccessMessage from '../components/success/success_msg.jsx';
import CONSTANTS from '../common_constants.jsx';

import authActions from '../auth/auth_actions';
import browsePackagesAction from './browser_packages_actions';
import {routerActions} from 'react-router-redux';
import {connect} from 'react-redux';
import {bindActionCreators} from 'redux';


class BrowsePackagesList extends React.Component{

  constructor(props){
    super(props);
    this.populateShipments = this.populateShipments.bind(this);
    this.updateListPackages = this.updateListPackages.bind(this);
    this.state = {
      isLoading: false,
      browseFilter: props.browsePackages.browseFilter,
      isFilterActive: props.browsePackages.isFilterActive,
      isFilterStateLocal: false,
      error: ''
    }
  }

  populateShipments(shipmentArr){
    if(shipmentArr == null || shipmentArr == undefined || shipmentArr == ''){
      return;
    }else{
      return shipmentArr.map((shipment, index) => (<ShipmentDetails key={index} shipment={shipment} />));
    }
  }

  updateListPackages = (nextUrl) => {
    let params = {
      isMapView: false,
      url: nextUrl
    }
    this.setState({
      isLoading: true
    })
    this.props.browsePackagesAction.updateListPackages(params).then((successData) => {
      this.setState({
        isLoading: false
      })
    }, (errorRes) => {
      this.setState({
        isLoading: false,
        error: errorRes.error
      })
    })
  }

  handleScrollPagination = () => {
    const {browsePackages}  = this.props;
    const self = this;
    let nextUrl;
    (browsePackages && browsePackages.list) ? (nextUrl = browsePackages.list.nextUrl): (nextUrl = null);
    if(nextUrl == null){
      return;
    }
    if( (nextUrl != '' || nextUrl != null || nextUrl != undefined) && !this.state.isLoading){
      this.updateListPackages.bind(self, nextUrl)();
    }else{
      return;
    }
  }

  getPackages(location, isMapView, browseFilterObj){
    const {props, state} = this;
    let browseFilter;
    (browseFilterObj == null || browseFilterObj == undefined) ? (browseFilter = this.state.browseFilter) : (browseFilter = browseFilterObj);
    let params = {
    	timestamp: 0,
    	count: 50,
    	isMapView: isMapView,
    	latitude: location.latitude,
    	longitude: location.longitude,
    	country: location.country
    }
    this.setState({
      isLoading: true
    })
    props.browsePackagesAction.browsePackages(params, browseFilter).then((successData) => {
      this.setState({
        isLoading: false
      })
    }, (errorRes)=>{
      this.setState({
        isLoading: false,
        error: errorRes.error
      })
    })
  }

  getListViewPackages = (location, browseFilter) => {
    let isMapView = false;
    this.getPackages(location, isMapView, browseFilter);
  }

  getMapViewPackages = (location, browseFilter) => {
    let isMapView = true;
    this.getPackages(location, isMapView, browseFilter);
  }

  clearBrowseFilter = (browseFilter) => {
    let location = {
      latitude: browseFilter.userLat,
      longitude: browseFilter.userLong,
      country: browseFilter.country,
      sensor: false
    };
      this.setState({browseFilter});
      if(this.state.isFilterActive){
        this.getListViewPackages(location, browseFilter);
        this.getMapViewPackages(location, browseFilter);
      }


  }

  updateParentState = (browseFilterChildState) => {

    this.setState({
      browseFilter: browseFilterChildState,
      isFilterStateLocal: false
    })

    if(browseFilterChildState.delivaryFrom != "" &&  browseFilterChildState.delivaryTo != ""){
        if(browseFilterChildState.delivaryFrom > browseFilterChildState.delivaryTo){
          this.setState({error: CONSTANTS.browseValidation});
          window.setTimeout( ()=>{
            this.setState({error: ""});
          }, 5000);
          return;
        }
    }

    let paramsList = {
      isMapView : false,
      count : 50,
      timestamp : 0
    }

    this.setState({isLoading: true});

    this.props.browsePackagesAction.searchBrowseShipments(browseFilterChildState, paramsList).then((successData) => {
      this.setState({isLoading: false});
    }, (errorRes)=>{
      this.setState({isLoading: false, error: errorRes.error});
    });


  }

  getListViewData = () => {
    const self = this;
    let browseFilter = Object.assign({}, self.state.browseFilter);
    let location = {
      latitude: 0,
      longitude: 0,
      country: '',
      sensor: false
    }
    let browseApicall = false;

    browseFilter.userLat = 0;
    browseFilter.userLong = 0;

    if (navigator.geolocation) {
      navigator.geolocation.getCurrentPosition(function(position){
        // console.log('navigator.geolocation)',navigator.geolocation);
        location.latitude = position.coords.latitude;
        location.longitude = position.coords.longitude;

        browseFilter.userLat = position.coords.latitude;
        browseFilter.userLong = position.coords.longitude;
        self.setState({browseFilter});

        self.props.browsePackagesAction.getCountryName(location).then((successData) => {
          successData.results[0].address_components.forEach( (address) => {
             if(address.types[0] == "country" &&  address.types[1] == "political"){
                 location.country = address.long_name;
                 browseFilter.country = address.long_name;
                 self.setState({browseFilter});
             }
             browseApicall = true;
          });
          // api call after country details are fetched
            self.getListViewPackages(location);
          }, (error) => {
            browseFilter.country = '';
            browseApicall = true;
            self.setState({isLoading: false, browseFilter: browseFilter});
            console.log('geo-country fetch failed');
            self.getListViewPackages(location);
          })

        }, () => {
          location.latitude = 0;
          location.longitude = 0;
          browseApicall = true;
          console.log('no-geo location current location failed');
          self.setState({browseFilter: browseFilter});
          self.getListViewPackages(location);
        }
        );
      }
      else{
        browseApicall = true;
        console.log('no geo location access api call ');
        self.getListViewPackages(location);
        self.setState({browseFilter: browseFilter});
      }


  }


  updateRoute = (selected) => {
    if(selected == 'Map View'){
      browserHistory.push('/browse-shipments/map');
    }
  }

  updateFilterState = () => {
    if(this.state.isFilterStateLocal){
      this.setState({isFilterStateLocal: false});
    }else{
      this.setState({isFilterStateLocal: true});
    }
  }


    componentDidMount(){

      const self = this;
      let lastScrollTop = 0;
      let currLocation;
      let pagetop = document.getElementById("app");
      let browseFilter = Object.assign({}, this.state.browseFilter);
      // call api only when scroll is towards down side
      // and near bottom of the page
      $(window).scroll( (event)=>{
         currLocation = $(window).scrollTop();
         if (currLocation > lastScrollTop){
              if( (window.innerHeight + window.pageYOffset) >= document.body.offsetHeight ){
                this.handleScrollPagination();
              }

         } else {

         }
         lastScrollTop = currLocation;

      });

      browseFilter = commonFunctions.addFilterKeysToState(browseFilter);

      this.setState({browseFilter});

      this.props.browsePackagesAction.clearMapData();

      if(!this.state.isFilterActive){
        this.getListViewData();
      }else{
        let browseFilter = Object.assign({}, this.state.browseFilter);
        let paramsList = {
          isMapView : false,
          count : 50,
          timestamp : 0
        }
        this.setState({isLoading: true});
        this.props.browsePackagesAction.searchBrowseShipments(browseFilter, paramsList).then((successData) => {
          this.setState({isLoading: false});
        }, (errorRes)=>{
          this.setState({isLoading: false, error: errorRes.error});
        });
      }

    }

    // unbind the component so that it doesn't cause the state issue
    componentWillUnmount() {
       $(window).unbind("scroll");
    }

    componentWillReceiveProps(newProps){

      let browseFilter = Object.assign({}, this.state.browseFilter);
      let isFilterActive = newProps.browsePackages.isFilterActive;

      browseFilter = commonFunctions.addFilterKeysToState(browseFilter);

      this.setState({browseFilter: browseFilter, isFilterActive: isFilterActive});

    }

  render(){
    const self = this;
    const {props, state} = this;
    const {browsePackages} = props;
    let shipmentArray;
    let shipmentComponent;
    let radioButtonNameArray = ['List View', 'Map View'];
    (browsePackages && browsePackages.list && browsePackages.list.shipmentList) ? (shipmentArray = browsePackages.list.shipmentList) : (shipmentArray = null);
    (browsePackages && shipmentArray && shipmentArray.length > 0) ? ( shipmentComponent = this.populateShipments(shipmentArray) ) : (shipmentComponent = null);
    return(
      <div className="list-view-wrap">
        <div className="header">
            <div className="wrapper cf">
              <div className="f-l" id="browsePackageHeader">Browse Packages</div>
              <MediaQuery query='(min-width: 767px)'>
                <div className="f-r">
                  <RadioButton radioButtonNameArray={radioButtonNameArray} selected={0} radioButtonName={'map_routes'} getValueCallback={this.updateRoute} />
                  {/*<div className="browse-route" onClick ={this.updateFilterState}>Filter</div>*/}
                </div>
              </MediaQuery>
              <MediaQuery query='(max-width: 767px)'>
                <div className="f-r browse-route" id="filterEnable" onClick ={this.updateFilterState}>Filter</div>
                <div className="f-r browse-route" onClick ={this.updateRoute.bind(self, 'Map View')}>Map</div>
              </MediaQuery>
            </div>
        </div>
        <MediaQuery query='(min-width: 768px)'>
          {<BrowseFilter browseFilter ={this.state.browseFilter} updateParenStateCallback={this.updateParentState} clearBrowseFilterCallback={this.clearBrowseFilter} />}
        </MediaQuery>
        <MediaQuery query='(max-width: 767px)'>
          {this.state.isFilterStateLocal && <BrowseFilter browseFilter ={this.state.browseFilter} updateParenStateCallback={this.updateParentState} clearBrowseFilterCallback={this.clearBrowseFilter} />}
        </MediaQuery>
        {this.state.error && <ShowError errorMessage = {this.state.error} />}
        {state.isLoading && <div className = "loader-wrapper"><div className = "loader"></div></div>}
        <MediaQuery query='(min-width: 768px)'>
          <div className="wrapper filter-sibling">
            {shipmentComponent}
            {!shipmentComponent &&
              <div className="empty-view-wrap">
                <div id="emptyHeader">Nothing to Carry</div><div id="emptyDescription">Check back later</div>
              </div>
            }
          </div>
        </MediaQuery>
        <MediaQuery query='(max-width: 767px)'>
          {!this.state.isFilterStateLocal && <div className="wrapper filter-sibling">
            {shipmentComponent}
            {!shipmentComponent &&
              <div className="empty-view-wrap">
                <div id="emptyHeader">Nothing to Carry</div><div id="emptyDescription">Check back later</div>
              </div>
            }
          </div>}
        </MediaQuery>

      </div>
    )
  }
}

BrowsePackagesList = connect((state) => {
  return {
    authState: state.app.auth,
    browsePackages: state.app.browsePackages
  }
}, (dispatch) => {
  return {
    authActions : bindActionCreators(authActions, dispatch),
    browsePackagesAction: bindActionCreators(browsePackagesAction, dispatch)
  }
})(BrowsePackagesList);

// browse package actions and auth actions might be required in future

export default BrowsePackagesList;



// WEBPACK FOOTER //
// app/browse_packages/browse_package_list.jsx